import {Approval} from './approval'

export class RuleApprovals {
    public sourceSystem: string
    public programme: string
    public productType: string
    public documentType: string
    public approvals = new Array<Approval>()
}
